import { AbortError } from '../AbortError';
import { BaseError } from '../BaseError';
import { isAbortError } from './isAbortError';
import { isNativeError } from './isNativeError';

// Проверяет, что ошибка определенного класса
export function isErrorType<T extends abstract new (...args: never) => unknown>(
    err: unknown,
    type: T
): err is InstanceType<T> {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- автоматический игнор в рамках DIRECT-265451. Исправьте при следующем редактировании при помощи type-assert, чтобы избежать возможных ложно-положительных проверок typecheck!
    // @ts-expect-error TS считает, что у типов нет пересечения. Поведение покрыто тестами.
    if (type === AbortError) {
        return isAbortError(err);
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- автоматический игнор в рамках DIRECT-265451. Исправьте при следующем редактировании при помощи type-assert, чтобы избежать возможных ложно-положительных проверок typecheck!
    // @ts-expect-error TS считает, что у типов нет пересечения. Поведение покрыто тестами.
    if (type === Error) {
        return isNativeError(err) || err instanceof BaseError;
    }

    if (typeof type === 'function') {
        return err instanceof type || (isNativeError(err) && err.name === type.name);
    }

    return false;
}
